<template>
  <svg width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 6.33348V7.99994H1.66646L6.58139 3.085L4.91494 1.41855L0 6.33348ZM7.86997 1.79644C8.04328 1.62313 8.04328 1.34316 7.86997 1.16985L6.8301 0.129984C6.65679 -0.0433279 6.37682 -0.0433279 6.20351 0.129984L5.39028 0.943215L7.05674 2.60967L7.86997 1.79644Z"
      fill="#F79B12"
    />
  </svg>
</template>

<script>
export default {
  name: 'Editing',
}
</script>

<style scoped></style>
